
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_14ina_193",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_14ina_1",
  "root": "awsui_root_mx3cw_14ina_215",
  "hidden": "awsui_hidden_mx3cw_14ina_250",
  "alert-wrapper": "awsui_alert-wrapper_mx3cw_14ina_298",
  "initial-hidden": "awsui_initial-hidden_mx3cw_14ina_310",
  "header": "awsui_header_mx3cw_14ina_315",
  "header-replacement": "awsui_header-replacement_mx3cw_14ina_316",
  "action": "awsui_action_mx3cw_14ina_320",
  "action-slot": "awsui_action-slot_mx3cw_14ina_324",
  "action-button": "awsui_action-button_mx3cw_14ina_325",
  "alert-focus-wrapper": "awsui_alert-focus-wrapper_mx3cw_14ina_329",
  "text": "awsui_text_mx3cw_14ina_360",
  "icon": "awsui_icon_mx3cw_14ina_367",
  "message": "awsui_message_mx3cw_14ina_370",
  "action-wrapped": "awsui_action-wrapped_mx3cw_14ina_374",
  "icon-size-medium": "awsui_icon-size-medium_mx3cw_14ina_378",
  "icon-size-big": "awsui_icon-size-big_mx3cw_14ina_382",
  "icon-size-normal": "awsui_icon-size-normal_mx3cw_14ina_386",
  "content": "awsui_content_mx3cw_14ina_390",
  "content-replacement": "awsui_content-replacement_mx3cw_14ina_391",
  "dismiss": "awsui_dismiss_mx3cw_14ina_395",
  "dismiss-button": "awsui_dismiss-button_mx3cw_14ina_400",
  "type-error": "awsui_type-error_mx3cw_14ina_404",
  "type-warning": "awsui_type-warning_mx3cw_14ina_412",
  "type-success": "awsui_type-success_mx3cw_14ina_420",
  "type-info": "awsui_type-info_mx3cw_14ina_428"
};
  